var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3358 3.66421C12.1168 2.88317 13.3832 2.88316 14.1642 3.66421L14.3358 3.83579C15.1168 4.61683 15.1168 5.88316 14.3358 6.66421L6.58579 14.4142C6.21071 14.7893 5.70201 15 5.17157 15L3 15L3 12.8284C3 12.298 3.21071 11.7893 3.58579 11.4142L11.3358 3.66421Z",
    stroke: "#949494"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.5L13.5 7.5",
    stroke: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditMedium);
export default __webpack_public_path__ + "static/media/edit-medium.c3248a79d51363a6faa2aafa50aa6aac.svg";
export { ForwardRef as ReactComponent };